/**
 * SmarterElements Library
 * 
 * A library of reusable UI components and utilities for building embeddable interfaces.
 * 
 * @packageDocumentation
 */

// Import polyfills for Node 12+ compatibility
import './polyfills';

// Core exports
export * from './core';

// Factory function
export { default as createSmarterElements } from './factory';

// Components
export { default as ElementModal } from './components/ElementModal';
export { ElementModalProvider, useElementModal } from './components/ElementModalProvider';

// Hooks
export * from './hooks';

// Utils
export * from './utils/event-bridge';
export { broadcastElementEvent } from './utils/event-bridge';
export { registerElementEventSchemas, getElementEventSchemas } from './utils/register-schemas';
export { createElementEventBroadcaster, createElementEvents } from './utils/element-events';
export type { ElementEventContext } from './utils/element-events';
export * from './utils/jwt';
// Explicit exports are not needed since we're using wildcard exports above
// Note: Removed references to non-existent modules
// export * from './utils/modal-keyboard';
// export * from './utils/utils';

// Types
export * from './types';

// Schemas
export { baseElementEvents, mergeWithBaseEvents, createEventNameGetter } from './schemas/base-element-schemas';
export type { ElementSchema } from './schemas/base-element-schemas';

// Re-export common types for backward compatibility
export interface ValidationResult {
  valid: boolean;
  errors?: string[];
}

export interface BroadcastResult {
  success: boolean;
  errors?: Error[];
}

// Default export for backward compatibility
import createSmarterElements from './factory';
export default createSmarterElements;
